import preferencesTypes from '../../constants/preferencesTypes'

export * from './getindex'
export * from './update'

const set_preferences_errors = (messages) => {
  return {
    type: preferencesTypes.set_errors,
    payload: messages
  }
}

const reset_preferences = () => {
  return {
    type: preferencesTypes.reset
  }
}

export {
  set_preferences_errors,
  reset_preferences,
}



// WEBPACK FOOTER //
// ./src/js/actions/preferences/index.js